import { render } from "./FilterItemParentFilter.vue?vue&type=template&id=18e7d52c"
import script from "./FilterItemParentFilter.vue?vue&type=script&lang=js"
export * from "./FilterItemParentFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__